import { useQuery } from '@tanstack/react-query'
import { axiosInstance } from '@/lib/axios'
import type { SubscriptionUsage } from '../types'

export function useQuerySubscriptionUsage(companyId: string | null | undefined) {
  return useQuery<SubscriptionUsage>({
    queryKey: ['subscription.usage', companyId],
    queryFn: async () => {
      const { data } = await axiosInstance.get<SubscriptionUsage>(
        `/config-api/${companyId}/subscription/usage`,
      )
      return data
    },
    enabled: !!companyId,
    staleTime: 30_000,
  })
}
